

import React, { useState, useEffect, useContext } from 'react';
//import RoleService from "../../../../services/SetupService/RoleService/RoleService";
import StockCategoryService from "../../controller/StockCategoryController/StockCategoryController";
import StockDiscountCategoryService from "../../../Parts/Controller/StockDiscountCategoryController";
import { useNavigate } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import { Link } from "react-router-dom";
import CreateStockCategory from './CreateStockCategory';
import HelpSite from "../../../Common/HelpLink";
import PartService from "../../../Parts/Controller/PartController";
import CustomerService from "../../../Customer/Controller/CustomerController";
import SupplierService from "../../../Supplier/Controller/SupplierController";
import CreateStock from "./CreateStock";
import CreateCustomer from "./CreateCustomer";
import CreateSupplier from "./CreateSupplier";
import DiscountTypeService from "../../../Setup/controller/DiscountTypeController/DiscountTypeController";
import { handleSubmit as CustomerDiscountSubmit } from "../../../Customer/Controller/CreateCustomerDiscountController";
import { handleSubmit as SupplierDiscountSubmit } from "../../../Supplier/Controller/CreateSupplierDiscountController";
import SupplierDiscountService from "../../../Supplier/Controller/SupplierDiscountController";
import CustomerDiscountService from "../../../Customer/Controller/CustomerDiscountController";
import Draggable from 'react-draggable';

import AssignCustomerList from "./AssignCustomerList";
import AssignPartList from "./AssignPartList";
import Swal from 'sweetalert2';
function RoleListPage({ show, onClose }) {
    const navigate = useNavigate();
    const [stockCategoryList, setStockCategories] = useState([]);

    const [stockList, setStockList] = useState([]);

    const [supplierList, setSupplierList] = useState([]);
    const [errors, setErrors] = useState({});
    const [partList, setPartData] = useState([]);
    const [AllCustomerList, setCustomerData] = useState([]);
    const [AllSupplierList, setSupplierData] = useState([]);
    const [showPartsModal, setShowPartsModal] = useState(false);
    const [showCustomerModal, setShowCustomerModal] = useState(false);

    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }


    const [isStockModalOpen, setIsStockModalOpen] = useState(false);
    const [isCustomerModalOpen, setIsCustomerModalOpen] = useState(false);
    const [isSupplierModalOpen, setSupplierIsModalOpen] = useState(false);
    const [isCreateSTockCategory, setIsCreateSTockCategory] = useState(false);
    const [currentStockCategory, setCurrentStockCategory] = useState(null);

    const [currentStoc, setCurrentStoc] = useState(null);
    const [currentCustomer, setCurrentCustomer] = useState(null);
    const [currentSupplier, setCurrentSupplier] = useState(null);
    const [DiscountsList, setDiscounts] = useState([]);
    const [selectedRow, setSelectedRow] = useState(null);
    const fetchStockCategory = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const data = await StockCategoryService.GetAllStckCategories(redirectCallback);
            setStockCategories(data);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    const fetchStocks = async (CategoryID) => {
        try {
            const data = await StockDiscountCategoryService.GetAllStockByCategoryID(CategoryID)
            setStockList(data);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };

    const fetchSuppliers = async (CategoryID) => {
        try {
            const data = await StockDiscountCategoryService.GetAllSupplierByCategoryID(CategoryID)
            setSupplierList(data);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    const fetchParts = async (CategoryID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            debugger;
            const data = await StockDiscountCategoryService.GetAllPartsForDiscountCategory(CategoryID, redirectCallback);
            setPartData(data);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };

    const fetchSupplierList = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const data = await SupplierService.GetAllSuppliers(redirectCallback);
            setSupplierData(data);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }

    };
    useEffect(() => {
        fetchDiscount();
        fetchStockCategory();
        fetchSupplierList();
    }, []);


    const handleCreateStockCategoryClick = () => {
        setCurrentStockCategory(null);
        setIsCreateSTockCategory(true);
    };

    const handleCreateStockClick = (stock) => {
        if (!validatePriceList()) return;

        setCurrentStoc(null);
        setIsStockModalOpen(true);
    };
    const handleCreateCustomerClick = () => {
        if (!validatePriceList()) return;

        setSelectedRow(selectedRow);
        // await fetchSuppliers(selectedRow);
        setShowCustomerModal(true);
    };

    const handleCreateSupplierClick = () => {
        if (!validatePriceList()) return;

        setCurrentSupplier(null);
        setSupplierIsModalOpen(true);
    };
    const handleCloseStockModal = () => {
        setShowPartsModal(false);
    };
    const handleCloseCustomerModal = () => {
        setShowCustomerModal(false);
    };
    const handleCloseSupplierModal = () => {
        setSupplierIsModalOpen(false);
    };

    const handleCloseModal = () => {
        setIsCreateSTockCategory(false);
    };
    const handleEditClick = (stock) => {
        setCurrentStockCategory(stock); // Set the team to be edited
        setIsCreateSTockCategory(true);
    };
    const fetchDiscount = async () => {
        try {
            const redirectCallback = () => navigate('/');
            const listOfDiscounts = await DiscountTypeService.GetAllDiscountTypes(redirectCallback);
            setDiscounts(listOfDiscounts);
        } catch (error) {
            console.error('Error fetching discounts:', error);
        }
    };
    const handleDeleteClick = async (ID) => {
        const confirmed = window.confirm("Are you sure you want to delete this team?");
        if (confirmed) {
            try {
                await StockCategoryService.DeleteStockCategory(ID);
                fetchStockCategory(); // Refresh the list after deletion
            } catch (error) {
                console.error('Error deleting Team:', error);
            }
        }
    };
    const handleDefaultToggle = async (ID, IsDefault) => {
        if (IsDefault === null || IsDefault === 0) {
            IsDefault = 1;
        }
        else {
            IsDefault = 0;
        }
        await StockCategoryService.SetDefaultStockCategory(ID, IsDefault);
        fetchStockCategory();
    }
    const validatePriceList = () => {
        if (!selectedRow) {
            Swal.fire({
                icon: "warning",
                title: "Price List Required",
                text: "Please select a Price List first."
            });
            return false;
        }
        return true;
    };
    const handleRowSelection = async (CategoryID) => {
        setSelectedRow(CategoryID);

        await fetchParts(CategoryID);
        await fetchStocks(CategoryID);
        await fetchSuppliers(CategoryID);
    };
    const handlePartSelect = async (event, parts, CategoryID) => {

        try {

            for (const part of parts) {

                const formData = {
                    ID: 0,
                    FK_Stock_ID: part.PK_Stock_ID,
                    FK_Stock_Category_ID: CategoryID,
                    SpecialPrice: part.SpecialPrice
                };

                await StockDiscountCategoryService.CreateStockDiscountCategory(
                    event,
                    formData
                );
            }

            Swal.fire(
                'Success!',
                'Selected parts assigned successfully.',
                'success'
            );


            handleRowSelection(CategoryID);
            handleCloseStockModal();

        } catch (error) {

            Swal.fire(
                'Error!',
                'Failed to assign selected parts.',
                'error'
            );
        }
    };

    const handleCustomerSelect = async (customers, data) => {

        const redirectCallback = () => {
            navigate('/');
        };

        let successCount = 0;
        let alreadyAssignedCount = 0;

        for (const customer of customers) {

            const formData = {
                ID: 0,
                FK_StockCategory_ID: data.FK_StockCategory_ID,
                FK_DiscountType_ID: data.FK_DiscountType_ID,
                FK_ClientCompany_ID: customer.ClientCompanyID,
                dec_Amount: data.dec_Amount
            };

            /*  const listOfDiscounts =
                  await CustomerDiscountService.GetAllCustomerDiscount(
                      redirectCallback,
                      customer.ClientCompanyID
                  );
  
              if (listOfDiscounts.length > 0) {
                  alreadyAssignedCount++;
                  continue;
              }*/

            const postData = await CustomerDiscountSubmit(
                null,
                formData,
                null,
                setErrors
            );

            if (postData.message === "User added successfully") {
                successCount++;
            }
        }

        if (successCount > 0) {
            Swal.fire(
                'Success!',
                `${successCount} customer(s) assigned successfully.${alreadyAssignedCount > 0
                    ? ` ${alreadyAssignedCount} customer(s) were already assigned.`
                    : ''
                }`,
                'success'
            );
        } else {
            Swal.fire(
                'Info',
                'All selected customers already have a discount category assigned.',
                'info'
            );
        }



        handleRowSelection(selectedRow);

        handleCloseCustomerModal();
    };


    const handleSupplierSelect = async (suppliers, data) => {

        const redirectCallback = () => {
            navigate('/');
        };

        let successCount = 0;
        let alreadyAssignedCount = 0;

        for (const supplier of suppliers) {

            const formData = {
                ID: 0,
                FK_StockCategory_ID: data.FK_StockCategory_ID,
                FK_DiscountType_ID: data.FK_DiscountType_ID,
                FK_Supplier_ID: supplier.PK_Supplier_ID,
                dec_Amount: data.dec_Amount
            };

            const listOfDiscounts = await SupplierDiscountService.GetAllSupplierDiscounts(redirectCallback, supplier.PK_Supplier_ID);

            if (listOfDiscounts.length > 0) {
                alreadyAssignedCount++;
                continue;
            }

            const postData = await SupplierDiscountSubmit(null, formData, null, setErrors);

            if (postData.message === "User added successfully") {
                successCount++;
            }
        }

        if (successCount > 0) {
            Swal.fire(
                'Success!',
                `${successCount} supplier(s) assigned successfully.${alreadyAssignedCount > 0
                    ? ` ${alreadyAssignedCount} supplier(s) were already assigned.`
                    : ''
                }`,
                'success'
            );
        } else {
            Swal.fire(
                'Info',
                'All selected customers already have a discount category assigned.',
                'info'
            );
        }
        handleRowSelection(data.FK_StockCategory_ID);

        handleCloseSupplierModal();
    };


    const handleDeleteStockClick = async (ID) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const redirectCallback = () => {
                        navigate('/'); // Redirect to the login page
                    };
                    await StockDiscountCategoryService.DeleteStockDiscountCategory(redirectCallback, ID);
                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );
                    handleRowSelection(selectedRow);

                } catch (error) {
                    console.error('Error deleting stock discount:', error);
                }
            }
        });
    };
    const handleDeleteCustomerClick = async (ID) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const redirectCallback = () => {
                        navigate('/'); // Redirect to the login page
                    };
                    await CustomerDiscountService.DeleteCustomerDiscount(ID, redirectCallback);
                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );
                    //  await fetchStockCategory();
                    //  await fetchCustomerList();
                    handleRowSelection(selectedRow);
                } catch (error) {
                    console.error('Error deleting Contact:', error);
                }
            }
        })
    };
    const handleDeleteSupplierClick = async (ID) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const redirectCallback = () => {
                        navigate('/'); // Redirect to the login page
                    };
                    await SupplierDiscountService.DeleteSupplierDiscounts(redirectCallback, ID);
                    handleRowSelection(selectedRow);
                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting Contact:', error);
                }
            }
        })
    };
    const handleStart = (e, ui) => e.stopPropagation();
    const HelpLink = localStorage.getItem('HelpLink');
    const truncateText = (text, maxLength = 20) => {
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };


    const handleStockListClick = async () => {
         if (!validatePriceList()) return;
        
        setSelectedRow(selectedRow);

        await fetchParts(selectedRow);
        await fetchStocks(selectedRow);

        setShowPartsModal(true);
    };

    const handleCustomerListClick = async () => {
        setSelectedRow(selectedRow);
        // await fetchSuppliers(selectedRow);
        setShowCustomerModal(true);
    };


    return (
        <div
            className={`modal fade ${show ? 'show' : ''}`}
            style={{ display: show ? 'block' : 'none' }}
            tabIndex="-1"
            aria-labelledby="partModalLabel"
            aria-hidden={!show}
        >
            <div className="modal-dialog modal-lg">
                <Draggable handle=".modal-content" onStart={handleStart}
                    cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="partModalLabel">Price Lists</h5>
                            <button type="button" className="close" onClick={onClose} aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="row mb-3" style={{ marginTop: "10px", marginLeft: "-5px", marginRight: "-5px" }}>

                                <div className="col-sm-6">
                                    <Link className='btn btn-primary btn-sm' onClick={handleCreateStockCategoryClick}>
                                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                                    </Link>
                                    &nbsp; &nbsp;
                                    <Link className='btn btn-secondary btn-sm' onClick={handleStockListClick}>
                                        <i className="icofont-plus" aria-hidden="true"> Assign Parts</i>
                                    </Link>
                                    &nbsp; &nbsp;
                                    <Link className='btn btn-warning  btn-sm' onClick={handleCreateCustomerClick}>
                                        <i className="icofont-plus" aria-hidden="true"> Assign Customer</i>
                                    </Link>
                                </div>
                                <div className="col-sm-6" style={{ "textAlign": "right" }}>
                                    <HelpSite FormName="Discounting" Module="26" />
                                </div>
                            </div>
                            <div className="row mb-3" style={{
                                marginTop: "10px", marginLeft: "5px", marginRight: "5px", maxHeight: "400px",
                                overflowY: "auto"
                            }}>
                                <table className="table m-0 table-hover">
                                    <thead className="sticky-top">
                                        <tr>
                                            <th style={{width:"5%"}}></th>
                                            <th>Price List</th>
                                            <th style={{ "textAlign": "right" }}>Actions</th>
                                        </tr>
                                    </thead><tbody>

                                        {stockCategoryList.map((stock, index) => (
                                            <tr key={stock.PK_StockCategory_ID} onClick={() => handleEditClick(stock)}
                                                style={{
                                                    cursor: 'pointer',
                                                    backgroundColor: selectedRow === stock.PK_StockCategory_ID ? '#c5daed' : 'transparent' // Change color as needed
                                                }}>
                                                <td  style={{width:"5%"}} onClick={(e) => e.stopPropagation()}><input
                                                    type="checkbox"
                                                    checked={selectedRow === stock.PK_StockCategory_ID}
                                                    onChange={() => handleRowSelection(stock.PK_StockCategory_ID)}
                                                /></td>
                                                <td>{stock.vc_Name}</td>
                                                <td style={{ "textAlign": "right" }}>
                                                   
                                                    <button className="text-danger" style={{ "background": "none", "border": "none" }} onClick={() => handleDeleteClick(stock.PK_StockCategory_ID)}>
                                                        <i className="icofont-ui-delete" aria-hidden="true"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>



                        </div>

                    </div>
                </Draggable>
                {isCreateSTockCategory && (
                    <CreateStockCategory show={isCreateSTockCategory} stock={currentStockCategory} onClose={handleCloseModal} onSuccess={fetchStockCategory} />
                )}



                {showPartsModal && (
                    <AssignPartList
                        show={showPartsModal}
                        onClose={handleCloseStockModal}
                        CategoryID={selectedRow}
                    />
                )}
                {showCustomerModal && (
                    <AssignCustomerList
                        show={showCustomerModal}
                        onClose={handleCloseCustomerModal}
                        CategoryID={selectedRow}
                    />
                )}
            </div>

        </div>
    );
}

export default RoleListPage;